import { COLORS } from '@btime/constants'
import { formatDate } from '@btime/helpers'
import { prop } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { RefetchingIndicator } from '../../../../components/helpers/StatePresenter'
import { importsClient } from '../../../../utils/apollo/api'
import { useImports } from '../_load/ImportsLoader'
import { useModalData } from '../../../../components/modals/ModalsContext'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import Icon from '../../../../components/shapes/Icon'
import ListCounter from '../../../../components/helpers/ListCounter'
import Loading from '../../../../packages/kiti/components/helpers/Loading'
import StatusTag from './StatusTag'

const ImportHistoryTable = () => {
  const { t } = useTranslation('import')
  const entity = useModalData()
  const data = useImports()

  const columns = [
    {
      label: t('date'),
      headerSideContent: (
        <>
          <ListCounter
            client={importsClient}
            entity="imports"
            filterName="ImportFilter"
            size="xsmall"
            bold
            filters={{ entities: entity }}
          />
          <RefetchingIndicator />
        </>
      ),
      dataIndex: 'insertedAt',
      flex: 2,
      bold: true,
      format: formatDate('DD/MM/YYYY HH:mm')
    },

    {
      label: t('doneBy'),
      dataIndex: 'createdBy',
      flex: 2,
      format: prop('name')
    },

    {
      label: t('status'),
      dataIndex: 'status',
      flex: 2,
      render: (status, record) => <StatusTag status={status} importRecord={record} />
    },

    {
      label: t('errorReport'),
      dataIndex: 'outputDocument',
      sortIndex: false,
      flex: 1,
      render: (data, record) =>
        !!data?.id ? (
          <a href={data?.src} target="_blank" rel="noopener noreferrer" download>
            <Icon name="RiDownloadCloud2Line" size="1rem" color={COLORS.red} />
          </a>
        ) : (
          record?.status === 'open' && <Loading type="spin" justify="flex-start" />
        )
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={data} inPanel size="medium" />
}

export default ImportHistoryTable
